import React from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchJson } from "@utils/fetchJson";
import HistoryItem from "@components/histroy/HistroyItem";
import { API_BASE_URL } from "@config";
import WSLoader from "@uiElements/WSLoader";

const fetchHistoryApi = async ({ pageParam = 0, queryKey }) => {
  const [_key, record_type, record_id, parent_record_type] = queryKey;

  return await fetchJson(`${API_BASE_URL}/history`, {
    method: "POST",
    body: JSON.stringify({
      type: record_type,
      record_id,
      pr_type: parent_record_type,
      status: "active",
      curpage: pageParam,
    }),
  });
};

const HistoryList = ({ record_id, record_type, parent_record_type }) => {
  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["history", record_type, record_id, parent_record_type],
    queryFn: fetchHistoryApi,
    getNextPageParam: (lastPage) =>
      lastPage?.loadstate ? lastPage?.paginginfo?.nextpage : undefined,

    enabled: !!record_id,
    refetchOnMount: true,  // 🔥 auto refresh on open
    staleTime: 0,          // 🔥 always refetch if invalidated
  });

  const historyList = data?.pages.flatMap((page) => page?.data || []) ?? [];

  return (
    <div className="bg-white p-0">
      <h2 className="text-base font-semibold mb-4">History</h2>

      {!isLoading && historyList.length === 0 && (
        <div className="text-center text-gray-500 py-6">No history found</div>
      )}

      {isError && (
        <div className="text-center text-red-500 py-6">
          Failed to load history.
        </div>
      )}

      {historyList.map((item) => (
        <HistoryItem key={item.history_id} item={item} />
      ))}

      {hasNextPage && (
        <div className="flex justify-center pt-2">
          <button
            onClick={() => fetchNextPage()}
            className="text-sm text-blue-500 mt-4"
            disabled={isFetchingNextPage}
          >
            {isFetchingNextPage ? "Loading..." : "Load More"}
          </button>
        </div>
      )}

      {isLoading && (
        <WSLoader></WSLoader>
      )}
    </div>
  );
};

export default HistoryList;
